// extracted by mini-css-extract-plugin
module.exports = {"PageHeader":"styles_PageHeader__25QNQ","dashboardTitle":"styles_dashboardTitle__nm4oI"};